import { useQuery } from "@apollo/client";

import { GET_LIST_RESERVATION } from "../TripReservationAPI";

/**
 * Liste des réservations de /admin/reservations.
 *
 * - `variables` vient de buildTripReservationsListVariables (seul point de
 *   construction des paramètres).
 * - `cache-and-network` : la liste est revalidée à chaque montage.
 * - `previousData` : pendant un changement de filtre ou de page, la liste
 *   précédente reste disponible pour ne pas vider la table.
 */
export const useListTripReservation = (variables, accessToken, skip = false) => {
  const query = useQuery(GET_LIST_RESERVATION, {
    variables,
    context: {
      headers: {
        authorization: accessToken ? `Bearer ${accessToken}` : "",
      },
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip,
  });

  const freshData = query.data?.QR_LIST_TRIP_RESERVATION?.data || null;
  const tripReservationsData =
    freshData || query.previousData?.QR_LIST_TRIP_RESERVATION?.data || null;

  return {
    tripReservationsData,
    freshData,
    loading: query.loading,
    // Une erreur sur la requête en cours l'emporte sur la page précédente.
    error: freshData ? null : query.error,
    refetch: query.refetch,
  };
};
